/* Native product forms are the baseline. No cart request runs during setup. */
(() => {
  if (!window.customElements || customElements.get('sun-quick-product')) return;

  class SunQuickProduct extends HTMLElement {
    connectedCallback() {
      if (this.form) return;
      const form = this.querySelector('form');
      const select = this.querySelector('[data-sun-quick-variant]');
      const quantity = this.querySelector('[data-sun-quick-quantity]');
      const button = this.querySelector('[data-sun-quick-add]');
      if (!form || !select || !quantity || !button) return;

      this.form = form;
      this.select = select;
      this.quantity = quantity;
      this.button = button;
      this.price = this.querySelector('[data-sun-quick-price]');
      this.error = this.querySelector('[data-sun-quick-error]');
      this.message = this.querySelector('[data-sun-quick-message]');
      this.cartLink = this.querySelector('[data-sun-quick-cart-link]');
      this.pending = false;
      this.select.addEventListener('change', () => {
        this.clearFeedback();
        this.updateSelection();
      });
      this.form.addEventListener('submit', (event) => this.addToCart(event));
      this.updateSelection();
    }

    updateSelection() {
      const option = this.select.selectedOptions[0];
      const available = Boolean(option && !option.disabled && option.dataset.available === 'true');
      if (this.price && option) {
        this.price.textContent = option.dataset.price;
        this.price.hidden = false;
      }
      this.button.disabled = this.pending || !available;
      this.button.textContent = this.pending ? 'Adding…' : available ? 'Add to cart' : 'Sold out';
      return available;
    }

    clearFeedback() {
      if (this.error) this.error.textContent = '';
      if (this.message) this.message.textContent = '';
      if (this.cartLink) this.cartLink.hidden = true;
    }

    async addToCart(event) {
      if (event.defaultPrevented) return;
      if (this.pending) {
        event.preventDefault();
        return;
      }
      // If enhancement is unavailable, allow Shopify's normal form submission.
      if (!window.fetch || !window.FormData || !this.dataset.cartAddUrl) return;
      event.preventDefault();
      this.clearFeedback();
      if (!this.updateSelection()) {
        if (this.error) this.error.textContent = 'Choose an available option.';
        return;
      }
      if (!this.form.reportValidity()) return;

      // Capture successful controls before locking this card during the request.
      const body = new FormData(this.form);
      this.pending = true;
      this.form.setAttribute('aria-busy', 'true');
      this.select.disabled = true;
      this.quantity.disabled = true;
      this.updateSelection();

      try {
        const response = await fetch(this.dataset.cartAddUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          body,
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          const detail = typeof result.description === 'string' ? result.description : result.message;
          if (this.error) this.error.textContent = typeof detail === 'string' ? detail : 'This item could not be added. Please check your selection and try again.';
        } else if (result.id || Array.isArray(result.items)) {
          if (this.message) this.message.textContent = 'Added to your cart.';
          this.dispatchEvent(new CustomEvent('lb:sunset-cart-added', {
            bubbles: true,
            detail: { quantity: Number.parseInt(body.get('quantity') || '1', 10) || 1 },
          }));
        } else {
          throw new Error('Unconfirmed cart response');
        }
      } catch {
        // An uncertain response may follow a successful add; never retry automatically.
        if (this.error) this.error.textContent = 'We couldn’t confirm the add. Check your cart before trying again.';
      } finally {
        this.pending = false;
        this.select.disabled = false;
        this.quantity.disabled = false;
        this.form.removeAttribute('aria-busy');
        if (this.cartLink) this.cartLink.hidden = false;
        this.updateSelection();
      }
    }
  }

  customElements.define('sun-quick-product', SunQuickProduct);
})();
